var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Info_card',{staticClass:"mb-2",attrs:{"info":_vm.info,"loading":_vm.loading}}),_c('status_list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }